/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner } from './PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner';
import {
    PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerFromJSON,
    PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerFromJSONTyped,
    PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerToJSON,
} from './PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner';

/**
 * 
 * @export
 * @interface PartnerStationDtoTimeZoneRulesTransitionsInnerDuration
 */
export interface PartnerStationDtoTimeZoneRulesTransitionsInnerDuration {
    /**
     * 
     * @type {number}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerDuration
     */
    seconds?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerDuration
     */
    nano?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerDuration
     */
    negative?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerDuration
     */
    zero?: boolean;
    /**
     * 
     * @type {Array<PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner>}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerDuration
     */
    units?: Array<PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInner>;
}

/**
 * Check if a given object implements the PartnerStationDtoTimeZoneRulesTransitionsInnerDuration interface.
 */
export function instanceOfPartnerStationDtoTimeZoneRulesTransitionsInnerDuration(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerDurationFromJSON(json: any): PartnerStationDtoTimeZoneRulesTransitionsInnerDuration {
    return PartnerStationDtoTimeZoneRulesTransitionsInnerDurationFromJSONTyped(json, false);
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerDurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerStationDtoTimeZoneRulesTransitionsInnerDuration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'seconds': !exists(json, 'seconds') ? undefined : json['seconds'],
        'nano': !exists(json, 'nano') ? undefined : json['nano'],
        'negative': !exists(json, 'negative') ? undefined : json['negative'],
        'zero': !exists(json, 'zero') ? undefined : json['zero'],
        'units': !exists(json, 'units') ? undefined : ((json['units'] as Array<any>).map(PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerFromJSON)),
    };
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerDurationToJSON(value?: PartnerStationDtoTimeZoneRulesTransitionsInnerDuration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'seconds': value.seconds,
        'nano': value.nano,
        'negative': value.negative,
        'zero': value.zero,
        'units': value.units === undefined ? undefined : ((value.units as Array<any>).map(PartnerStationDtoTimeZoneRulesTransitionsInnerDurationUnitsInnerToJSON)),
    };
}

